<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px;padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.search.type"
              placeholder="请选择类型"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.search.businessName"
              placeholder="请输入业务单据名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-select
              v-model="masterList.tableQuery.search.status"
              placeholder="请选择状态"
              clearable
              style="width:100%"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>
      <!-- 数据列表 -->
      <custom-table
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        is-index-field
        is-paging
        @reloadData="loadTableData()"
        @add="addFun"
        @edit="editFun(arguments)"
        @remove="removeFun(arguments)"
        @enable="enableFun(arguments)"
        @disable="disableFun(arguments)"
        @view="viewFun(arguments)"
        @dblclick="viewFun(arguments)"
        @export="batchExport(masterList)"
      />
    </div>

    <!-- 新增 修改 -->
    <add-edit-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogAddEditVisible"
      @reloadData="loadTableData()"
    />

    <!-- 查看 -->
    <view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogTitle"
      :dialog-visible.sync="dialogViewVisible"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation from '@/components/TableOperation'
// 列表设置tableKeyMixin
import tableOperationMixin from '@/mixin/tableOperationMixin'
// 导出 batchExportMixin
import batchExportMixin from '@/mixin/batchExportMixin'
// 自定义Table
import CustomTable from '@/components/CustomTable'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin from '@/mixin/tableCustomMixin'
// 新增 修改
import addEditDialog from './components/addEditDialog'
// 查看
import viewDialog from './components/viewDialog'
// 数据请求
import { loadMessageNotifyPersonnelListDataApi, loadMessageNotifyPersonnelExportDataApi, saveOrUpdateMessageNotifyPersonnelApi } from '@/api/messageNotifyPersonnel'

export default {
  name: 'MessageNotifyPersonnel',
  components: {
    CustomTable,
    TableOperation,
    addEditDialog,
    viewDialog,
  },
  mixins: [tableCustomMixin, tableOperationMixin, batchExportMixin],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'message_notify_personnel_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: true, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['message_notify_setting_add'],
            prop: 'add',
            label: '创建',
            method: 'add'
          },
          {
            permissionSigns: ['message_notify_setting_edit'],
            prop: 'edit',
            label: '修改',
            method: 'edit'
          },
          {
            permissionSigns: ['message_notify_setting_edit'],
            prop: 'enable',
            label: '启用',
            method: 'enable'
          },
          {
            permissionSigns: ['message_notify_setting_edit'],
            prop: 'disable',
            label: '停用',
            method: 'disable'
          },
          {
            permissionSigns: ['message_notify_setting_delete'],
            prop: 'removeFun',
            label: '作废',
            method: 'remove'
          },
          {
            permissionSigns: ['message_notify_setting_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['message_notify_setting_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          page: 1, // 页数
          limit: 50, // 每页条数
          contextmenuWrap: [], // 右键筛选字段
          // 排序对象
          sort: {
            prop: '', // 排序字段
            order: '' // 排序类型 asc升序 desc降序
          },
          // 查询条件
          search: {
            type: '',
            businessName: '',
            status: ''
          }
        }
      },
      typeOptions: [{ value: 1, label: '实时触发' }, { value: 2, label: '定时触发' }],
      statusOptions: [{ value: 1, label: '启用' }, { value: 2, label: '停用' }],
      nodeOptions: [
        { value: 1, label: '创建' }, { value: 2, label: '提交' }, { value: 3, label: '复核' }, { value: 4, label: '退回' },
        { value: 5, label: '确认发货' }, { value: 6, label: '确认总部制作' }, { value: 7, label: '确认当地制作' }, { value: 8, label: '确认调拨' },
      ],
      personnelTypeOptions: [{ value: 1, label: '业务单据相关人员' }, { value: 3, label: '自定义人员' }, { value: 2, label: '出库库房管理员' }, { value: 4, label: '库房收货人' }],
      id: null, // 选中的单据ID
      eventType: '',
      dialogTitle: '',
      dialogAddEditVisible: false,
      dialogViewVisible: false
    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'typeValue', label: '消息触发类型', filterColumn: 'type', filterValue: 'type', filterArray: this.typeOptions, width: 125 },
      { prop: 'businessName', label: '业务单据', filterColumn: 'business_name', width: 120 },
      { prop: 'nodeValue', label: '消息触发节点', filterColumn: 'node', filterValue: 'node', filterArray: this.nodeOptions, width: 125 },
      { prop: 'provinceName', label: '省区', filterColumn: 'province_name', width: 100 },
      { prop: 'cityName', label: '城市', filterColumn: 'city_name', width: 100 },
      { prop: 'personnelTypeValue', label: '消息通知人员类型', filterColumn: 'personnel_type', filterValue: 'personnelType', filterArray: this.personnelTypeOptions, width: 160 },
      { prop: 'businessOperator', label: '业务单据相关人员', filterColumn: 'business_operator', width: 200 },
      { prop: 'userNames', label: '自定义通知人员', filterColumn: 'user_names' },
      { prop: 'statusValue', label: '状态', filterColumn: 'rv.status', filterValue: 'status', filterArray: this.statusOptions, width: 100 },
      { prop: 'operator', filterColumn: 'operator', label: '操作人', width: 100 },
      { prop: 'operateTimeValue', filterColumn: 'operate_time', label: '操作时间', width: 150, isBetween: true }
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      this.masterList.tableLoading = true
      loadMessageNotifyPersonnelListDataApi({ condition: JSON.stringify(this.masterList.tableQuery) }).then(response => {
        this.masterList.tableLoading = false
        let data = response.data.data || []
        this.handleData(data)
        this.masterList.tableDataTotal = response.data.recordsTotal || 0
      }).catch()
    },
    // 新增
    addFun () {
      this.eventType = 'add'
      this.dialogTitle = '创建消息通知设置'
      this.dialogAddEditVisible = !this.dialogAddEditVisible
    },
    // 修改
    editFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要修改的消息通知设置', type: 'warning' })
        return
      }
      this.id = args[0].id
      this.eventType = 'edit'
      this.dialogTitle = '修改消息通知设置'
      this.dialogAddEditVisible = !this.dialogAddEditVisible
    },
    // 查看
    viewFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要查看的消息通知设置', type: 'warning' })
        return
      }
      this.id = args[0].id
      this.eventType = 'view'
      this.dialogTitle = '查看消息通知设置'
      this.dialogViewVisible = !this.dialogViewVisible
    },
    // 作废
    removeFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要作废的消息通知设置', type: 'warning' })
        return
      }
      this.$confirm(
        '是否确定作废该消息通知设置？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }
      ).then(async () => {
        saveOrUpdateMessageNotifyPersonnelApi({ id: args[0].id, isDelete: "true" }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 启用
    enableFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要复核的消息通知设置', type: 'warning' })
        return
      } else if (args[0].status !== 2) {
        this.$message({ message: '消息通知设置不在停用状态，不能启用', type: 'warning' })
        return
      }
      this.$confirm(
        '是否确定启用该消息通知设置？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }
      ).then(async () => {
        saveOrUpdateMessageNotifyPersonnelApi({ id: args[0].id, isEnable: "true" }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 停用
    disableFun (args) {
      if (!args[0]) {
        this.$message({ message: '请选择要反复核的消息通知设置', type: 'warning' })
        return
      } else if (args[0].status !== 1) {
        this.$message({ message: '消息通知设置不在启用状态，不能停用', type: 'warning' })
        return
      }
      this.$confirm(
        '是否确定停用该消息通知设置？', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true }
      ).then(async () => {
        saveOrUpdateMessageNotifyPersonnelApi({ id: args[0].id, isDisable: "true" }).then(res => {
          if (res.mark === '200') {
            this.$message({ message: res.message, type: 'success' })
            this.loadTableData()
          }
        })
      }).catch(() => { })
    },
    // 导出数据API
    ExportByPage () {
      loadMessageNotifyPersonnelExportDataApi({ condition: JSON.stringify(this.exportObj) }).then(res => {
        let exportObj = { exportSuccess: true, url: res.data }
        this.$store.dispatch('message/settingExportSuccess', exportObj)
      })
    }
  }
}
</script>
